import leftDecoration from '@/assets/images/school-portal/left.png';
import schoolIcon from '@/assets/images/school-portal/schoolIcon.png';
import { cn } from '@/lib/tailwind-utils.js';
import type { ReactNode } from 'react';

export interface SchoolPortalBannerProps {
  title: ReactNode;
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  'data-testid'?: string;
}

export function SchoolPortalBanner({
  title,
  children,
  className,
  contentClassName,
  'data-testid': dataTestId,
}: SchoolPortalBannerProps) {
  return (
    <div className={cn('relative -mx-3 md:-mx-4 lg:-mx-6', className)}>
      <div className="relative h-36 overflow-hidden bg-[#EB404A] px-6 pt-6 md:px-8 lg:px-10">
        <img
          src={leftDecoration}
          alt=""
          aria-hidden
          className="pointer-events-none absolute inset-y-0 left-0 h-full w-auto max-w-none select-none"
        />
        <img
          src={schoolIcon}
          alt=""
          aria-hidden
          className="pointer-events-none absolute inset-y-0 right-0 h-full w-auto max-w-none select-none pt-[0.1rem]"
        />
        <h2 className="relative z-10 flex items-center gap-2 text-xl font-bold text-white" data-testid={dataTestId}>
          <span className="h-6 w-[6px] shrink-0 bg-white" aria-hidden />
          {title}
        </h2>
      </div>

      <div className={cn('relative z-10 -mt-16 px-3 md:px-4 lg:px-6', contentClassName)}>{children}</div>
    </div>
  );
}
